import React from 'react';
import { MenuItem } from '../types';
import { useMerchant } from '../context/MerchantContext';
import { useCart } from '../context/CartContext';
import ProductImage from './common/ProductImage';

interface SuggestedProductCardProps {
  item: MenuItem;
  tag?: string;
}

const SuggestedProductCard: React.FC<SuggestedProductCardProps> = ({ item, tag }) => {
  const { setProductModalData, restaurant } = useMerchant();
  const { addItem } = useCart();

  const primaryColor = restaurant?.theme?.primary || '#e74c3c';

  const handleAddClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    
    // Check if product has mandatory modifiers/extras
    const hasMandatoryModifiers = (item as any).modifiers?.some((m: any) => m.required) || 
                                 item.extras?.some(e => e.required);

    if (hasMandatoryModifiers) {
      // Open modal if it has mandatory options
      setProductModalData({ item, editMode: false } as any);
    } else {
      // Add directly to cart if simple
      addItem(item, 1);
    }
  };

  const handleCardClick = () => {
    setProductModalData({ item, editMode: false } as any);
  };

  const formattedPrice = new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(item.price);

  return (
    <div 
      className="card border-0 shadow-sm rounded-4 overflow-hidden h-100 transition-all hover-translate-up cursor-pointer bg-white"
      style={{ minWidth: '140px' }}
      onClick={handleCardClick}
    >
      <div className="position-relative" style={{ height: '110px' }}>
        <ProductImage 
          src={item.image} 
          alt={item.name}
          className="w-100 h-100 object-fit-cover shadow-sm"
        />
        {tag && (
          <div className="position-absolute top-0 start-0 m-2">
            <span 
              className="badge text-white shadow-sm"
              style={{ fontSize: '0.65rem', padding: '4px 8px', backgroundColor: primaryColor, borderRadius: '6px' }}
            >
              {tag}
            </span>
          </div>
        )}
      </div>
      <div className="card-body p-2 d-flex flex-column justify-content-between">
        <div className="mb-2">
          <h4 className="fw-bold text-dark mb-1 text-truncate" title={item.name} style={{ fontSize: '0.85rem' }}>
            {item.name}
          </h4>
          <span className="fw-bold d-block" style={{ fontSize: '0.85rem', color: primaryColor }}>
            {formattedPrice}
          </span>
        </div>
        <button 
          className="btn btn-sm w-100 py-2 rounded-3 fw-bold text-white shadow-sm"
          onClick={handleAddClick}
          style={{ fontSize: '0.8rem', backgroundColor: primaryColor, border: 'none' }}
        >
          <i className="fas fa-plus me-1"></i> Adicionar
        </button>
      </div>
    </div>
  );
};

export default SuggestedProductCard;
